(() => {
  if (window.PKCheckout) return;
  const root = window.Shopify?.routes?.root || '/';
  const key = 'peak_checkout_initiated_v1';
  const switchProperty = '_pk_checkout_switch';
  const saunaHandles = new Set(["peak-saunas-mini-1-person-indoor-full-spectrum-infrared-sauna-with-medical-grade-red-light-therapy", "peak-saunas-shasta-1-person-indoor-near-zero-emf-full-spectrum-infrared-sauna-with-xl-medical-grade-red-light-therapy-smart-wifi-app-control", "peak-saunas-rainier-1-person-indoor-near-zero-emf-full-spectrum-infrared-sauna-with-xl-medical-grade-red-light-therapy-smart-wifi-app-control", "peak-saunas-crown-2-person-full-spectrum-infrared-sauna", "peak-saunas-everest-2-person-indoor-near-zero-emf-full-spectrum-infrared-sauna-with-medical-grade-red-light-therapy", "peak-saunas-fuji-2-person-indoor-near-zero-emf-full-spectrum-infrared-sauna-with-medical-grade-red-light-therapy", "peak-saunas-denali-3-person-full-spectrum-infrared-sauna-with-two-xl-medical-grade-red-light-therapy-smart-wifi-app-control", "peak-saunas-matterhorn-3-person-full-spectrum-infrared-sauna-with-two-xl-medical-grade-red-light-therapy-smart-wifi-app-control", "peak-saunas-patagonia-2-person-outdoor-full-spectrum-infrared-sauna-with-smart-wifi-app-control", "peak-saunas-el-capitan-4-person-outdoor-full-spectrum-infrared-sauna-with-smart-wifi-app-control", "peak-saunas-kilimanjaro-5-person-outdoor-full-spectrum-infrared-sauna-with-smart-wifi-app-control"]);
  const knownGifts = new Set(['52025885360429','51911317782829','50522160824621','51541859303725','67700248576301']);
  const labels = () => window.PKCheckoutText || {};
  const text = (name, values = {}) => Object.entries(values).reduce((value, [token, replacement]) => value.replaceAll('__' + token + '__', replacement), labels()[name] || '');
  let pending = false, generation = 0, refreshVersion = 0, activePrompt = null;
  const buttons = new Map();
  const track = (event, details = {}) => { try { window.PK?.track?.(event, details); } catch {} };
  const normalize = a => {
    if (!a.getAttribute('href')?.includes('peak-explore')) return;
    try {
      const u = new URL(a.href, location.href);
      if (u.origin !== location.origin || !u.pathname.includes('/products/') || u.searchParams.get('view') !== 'peak-explore') return;
      u.searchParams.delete('view'); a.href = u.pathname + u.search + u.hash;
    } catch {}
  };
  const scan = node => {
    if (node.nodeType !== 1) return;
    if (node.matches('a[href]')) normalize(node);
    node.querySelectorAll('a[href*="peak-explore"]').forEach(normalize);
  };
  scan(document.documentElement);
  new MutationObserver(records => records.forEach(r => {
    if (r.type === 'attributes') normalize(r.target); else r.addedNodes.forEach(scan);
  })).observe(document.body, { subtree:true, childList:true, attributes:true, attributeFilter:['href'] });

  const request = (path, body) => new Promise((resolve, reject) => {
    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const options = {credentials:'same-origin',cache:'no-store'};
    if (controller) options.signal = controller.signal;
    if (body) Object.assign(options,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
    let done = false;
    const finish = (fn, value) => { if (done) return; done = true; clearTimeout(timer); fn(value); };
    const timer = setTimeout(() => {
      finish(reject, new Error('cart_request_timeout'));
      if (controller) controller.abort();
    }, 15000);
    Promise.resolve().then(() => window.fetch(root + path, options)).then(async response => {
      const data = await response.json().catch(() => null);
      if (!response.ok) {
        const error = new Error('cart_request_failed');
        const message = data && (data.description || data.message);
        if (typeof message === 'string' && message.length <= 500) error.shopifyMessage = message;
        throw error;
      }
      if (!data) throw new Error('cart_response_invalid');
      return data;
    }).then(data => finish(resolve,data), error => finish(reject,error));
  });
  const isSauna = item => saunaHandles.has(item.handle) || /infrared sauna/i.test(item.product_type || '');
  const nameOf = item => (item.product_title || item.title || item.handle || '').replace(/^Peak(?: Saunas)?\s+/i,'').replace(/\s+\d[- ]Person.*$/i,'').trim();
  const summary = items => items.map(item => text('quantity', {MODEL:nameOf(item),QUANTITY:String(item.quantity)})).join(', ');
  const remember = cart => {
    const items = cart.items || [], saunas = items.filter(isSauna), ready = saunas.some(item => item.quantity > 0) || items.some(item => item.quantity > 0 && item.final_price > 0);
    try {
      if (ready) localStorage.setItem(key, JSON.stringify({token:cart.token,started:Date.now(),variant:saunas[0]?.variant_id || null}));
      else localStorage.removeItem(key);
    } catch {}
    const label = summary(saunas.length ? saunas : items);
    document.body.classList.toggle('pkj-checkout-ready', ready);
    document.querySelectorAll('[data-pk-checkout-resume]').forEach(button => {
      button.hidden = !ready;
      button.href = root + 'checkout';
      button.dataset.checkoutReady = String(ready);
      button.setAttribute('aria-label', text('resume_label', {CURRENT:label}));
      if (!buttons.has(button)) button.textContent = text('resume');
    });
    document.querySelectorAll('[data-pk-checkout-summary]').forEach(node => { node.textContent = label; node.hidden = !ready; });
    return ready;
  };
  const refresh = async () => {
    const version = ++refreshVersion;
    try { const cart = await request('cart.js'); if (version === refreshVersion && !pending) remember(cart); return cart; }
    catch { return null; }
  };
  const setBusy = button => {
    if (!button || buttons.has(button)) return;
    buttons.set(button, {html:button.innerHTML,disabled:button.disabled});
    button.setAttribute('aria-busy','true');
    button.setAttribute('aria-disabled','true');
    if (button.tagName === 'BUTTON') button.disabled = true;
    button.textContent = text('loading');
  };
  const resetButtons = () => {
    buttons.forEach((state, button) => {
      button.innerHTML = state.html;
      if (button.tagName === 'BUTTON') button.disabled = state.disabled;
      button.removeAttribute('aria-busy');button.removeAttribute('aria-disabled');
    });
    buttons.clear();
  };
  const statusFor = button => {
    const host = button?.closest('.pk-direct-actions') || button?.parentElement || document.querySelector('#MainContent') || document.body;
    let status = host.querySelector('.pk-checkout-status');
    if (!status) { status = document.createElement('p'); status.className = 'pk-checkout-status';status.setAttribute('role','status');status.setAttribute('aria-live','polite');host.append(status); }
    return status;
  };
  const clearStatus = () => document.querySelectorAll('.pk-checkout-status').forEach(node => { node.hidden = true;node.textContent = ''; });
  const showError = (button, message) => { const status = statusFor(button);status.textContent = message;status.hidden = false; };
  const dismissPrompt = () => { if (activePrompt) activePrompt(false); };
  const confirmSwitch = (button, model, existing, quantity = 1) => new Promise(resolve => {
    dismissPrompt();
    const host = button?.closest('.pk-direct-actions') || button?.parentElement || document.querySelector('#MainContent') || document.body;
    const panel = document.createElement('div');panel.className = 'pk-checkout-confirm';panel.setAttribute('role','group');panel.setAttribute('aria-label',text('switch_title'));
    const title = document.createElement('strong');title.textContent = text('switch_title');
    const copy = document.createElement('p');copy.textContent = text('switch_body',{CURRENT:summary(existing),MODEL:text('quantity',{MODEL:model,QUANTITY:String(quantity)})});
    const actions = document.createElement('div');actions.className='pk-checkout-confirm__actions';
    const yes = document.createElement('button');yes.type='button';yes.dataset.pkSwitchConfirm='';yes.textContent=text('switch_action',{MODEL:model});
    const no = document.createElement('button');no.type='button';no.dataset.pkSwitchCancel='';no.textContent=text('keep_action',{CURRENT:summary(existing)});
    const finish = value => { if (activePrompt === finish) activePrompt = null;panel.remove();resolve(value); };
    activePrompt = finish;
    yes.addEventListener('click',()=>finish(true));no.addEventListener('click',()=>finish(false));
    actions.append(yes,no);panel.append(title,copy,actions);host.append(panel);yes.focus();
  });
  const fieldsFrom = form => {
    const result = {properties:{}};
    if (!form) return result;
    for (const [name, value] of new FormData(form)) {
      if (name === 'quantity' && /^\d+$/.test(String(value)) && Number(value) > 0) result.quantity = Number(value);
      if (name === 'selling_plan' && value) result.selling_plan = String(value);
      const match = name.match(/^properties\[(.+)\]$/);
      if (match && typeof value === 'string') result.properties[match[1]] = value;
    }
    return result;
  };
  // A marked line records a switch that has not finished. It survives page reloads in the cart itself.
  const pendingSwitch = cart => {
    for (const item of cart.items || []) {
      let details;
      try { details = JSON.parse(item.properties?.[switchProperty] || 'null'); } catch { continue; }
      if (!details || String(details.variant) !== String(item.variant_id)) continue;
      const others = cart.items.filter(line => isSauna(line) && String(line.variant_id) !== String(item.variant_id));
      if (others.length) return {item,details,others};
    }
    return null;
  };
  const showRecovery = (button, conflict) => {
    dismissPrompt();
    const host = button?.closest('.pk-direct-actions') || button?.parentElement || document.querySelector('#MainContent') || document.body;
    const panel = document.createElement('div');panel.className='pk-checkout-confirm';panel.setAttribute('role','group');panel.setAttribute('aria-label',text('recovery_title'));
    const title=document.createElement('strong');title.textContent=text('recovery_title');
    const copy=document.createElement('p');copy.textContent=text('recovery_body',{CURRENT:summary(conflict.others),MODEL:summary([conflict.item])});
    const actions=document.createElement('div');actions.className='pk-checkout-confirm__actions';
    const yes=document.createElement('button');yes.type='button';yes.dataset.pkSwitchConfirm='';yes.textContent=text('switch_action',{MODEL:nameOf(conflict.item)});
    const no=document.createElement('button');no.type='button';no.dataset.pkSwitchCancel='';no.textContent=text('keep_action',{CURRENT:summary(conflict.others)});
    const close=()=>{panel.remove();if(activePrompt===close)activePrompt=null;};activePrompt=close;
    yes.addEventListener('click',()=>{close();start({variant:conflict.item.variant_id,model:nameOf(conflict.item),gifts:conflict.details.gifts,productId:conflict.details.productId,button,placement:'switch_recovery'});});
    no.addEventListener('click',()=>{close();keepPrevious(button,conflict);});
    actions.append(yes,no);panel.append(title,copy,actions);host.append(panel);yes.focus();
  };
  const keepPrevious = async (button, confirmed) => {
    if (pending) return false;
    clearStatus();pending=true;const run=++generation;setBusy(button);
    try {
      let cart=await request('cart.js');if(run!==generation)return false;
      const conflict=pendingSwitch(cart);
      if (conflict) {
        if (conflict.item.properties[switchProperty]!==confirmed.item.properties[switchProperty] || conflict.item.quantity!==confirmed.item.quantity || otherSignature(conflict.others)!==otherSignature(confirmed.others)) {
          showRecovery(button,conflict);return false;
        }
        cart=await request('cart/change.js',{id:conflict.item.key,quantity:0});if(run!==generation)return false;
      }
      remember(cart);track('pk_checkout_cancel',{placement:'switch_recovery'});
      if(pendingSwitch(cart)){showRecovery(button,pendingSwitch(cart));return false;}
      if(remember(cart)){location.assign(root+'checkout');return true;}
      return false;
    } catch(error){showError(button,text('recovery_error'));track('pk_checkout_error',{placement:'switch_recovery',reason:error.message || 'unknown'});return false;}
    finally{if(run===generation){pending=false;resetButtons();}}
  };
  const otherSignature = items => items.map(item=>`${item.key}:${item.quantity}`).sort().join('|');
  const start = async options => {
    if (pending) return false;
    dismissPrompt();clearStatus();
    pending = true; const run = ++generation;const button=options.button;
    let switchToken = '', originalOthers = '';
    const current = () => { if (run !== generation) throw new Error('superseded'); };
    const variant = String(options.variant || ''), placement = options.placement || 'pdp';
    const purchaseSauna = !options.productHandle || saunaHandles.has(options.productHandle);
    const model = nameOf({title:options.model || ''});
    const event = {product_id:String(options.productId || ''),variant_id:variant,placement};
    track('pk_checkout_intent',event);setBusy(button);
    try {
      if (!/^\d+$/.test(variant)) throw new Error('missing_variant');
      let cart = await request('cart.js');current();
      let others = cart.items.filter(item=>purchaseSauna && isSauna(item) && String(item.variant_id)!==variant);
      let confirmed = '';
      while (others.length && confirmed !== otherSignature(others)) {
        const signature = otherSignature(others);
        resetButtons();
        const selectedQuantity=cart.items.filter(item=>String(item.variant_id)===variant).reduce((total,item)=>total+item.quantity,0) || 1;
        const accepted = await confirmSwitch(button,model,others,selectedQuantity);current();
        if (!accepted) {track('pk_checkout_cancel',event);remember(cart);return false;}
        track('pk_checkout_switch',event);setBusy(button);
        cart = await request('cart.js');current();
        others = cart.items.filter(item=>purchaseSauna && isSauna(item) && String(item.variant_id)!==variant);
        confirmed = signature;
      }
      const assemblyIntent = window.PKAssembly ? await window.PKAssembly.prepare(variant, cart) : null;current();
      const selected = cart.items.filter(item=>String(item.variant_id)===variant);
      const fields = fieldsFrom(options.form);
      const preorder = options.form && (window.PKJ_PO?.on || document.documentElement.getAttribute('data-pk-preorder-guard')==='on');
      if (preorder && !fields.selling_plan) throw new Error('preorder_wait');
      if (preorder) {
        for (const item of selected) {
          if (!item.selling_plan_allocation) {
            cart = await request('cart/change.js',{id:item.key,quantity:item.quantity,properties:{...(item.properties || {}),...fields.properties},selling_plan:fields.selling_plan});current();
          }
        }
      }
      const gifts = [...new Set((options.gifts || []).map(String).filter(id=>/^\d+$/.test(id)))];
      const present = new Set(cart.items.map(item=>String(item.variant_id)));
      const items = gifts.filter(id=>!present.has(id)).map(id=>({id,quantity:1}));
      if (!selected.length) {
        if (others.length) {
          switchToken=JSON.stringify({variant,gifts,productId:options.productId || '',nonce:Date.now()+':'+Math.random()});
          originalOthers=otherSignature(others);
          fields.properties[switchProperty]=switchToken;
        }
        items.unshift({id:variant,quantity:1,...fields});
      }
      if (items.length) {await request('cart/add.js',{items});current();cart=await request('cart.js');current();}
      const changedOthers = cart.items.filter(item=>purchaseSauna && isSauna(item) && String(item.variant_id)!==variant);
      if (otherSignature(changedOthers)!==otherSignature(others)) throw new Error('selection_changed');
      const updates = {};
      changedOthers.forEach(item=>{updates[item.key]=0;});
      cart.items.forEach(item=>{
        const id=String(item.variant_id);
        if (purchaseSauna && knownGifts.has(id) && !gifts.includes(id) && item.final_price === 0) updates[item.key]=0;
      });
      if (Object.keys(updates).length) {cart=await request('cart/update.js',{updates});current();}
      if (!cart.items.some(item=>String(item.variant_id)===variant && item.quantity>0)) throw new Error('missing_selection');
      if (purchaseSauna && cart.items.some(item=>isSauna(item) && String(item.variant_id)!==variant)) throw new Error('selection_changed');
      // Remove the private marker only after the selected sauna is the only sauna left.
      for (const item of cart.items.filter(line=>String(line.variant_id)===variant && line.properties?.[switchProperty])) {
        const properties={...item.properties,[switchProperty]:''};
        cart=await request('cart/change.js',{id:item.key,quantity:item.quantity,properties});current();
      }
      if (window.PKAssembly) {cart=await window.PKAssembly.sync(variant, cart, assemblyIntent);current();}
      remember(cart);
      try { window.PK?.themeArmWrite?.('checkout'); } catch {}
      track('pk_checkout_success',event);
      location.assign(root+'checkout');return true;
    } catch (error) {
      if (error.message==='superseded') return false;
      // Roll back only our exact new line, and only while the original selection is unchanged.
      // If that write also fails, the cart marker makes every later resume stop for an explicit choice.
      let unresolved = null;
      try {
        let cart=await request('cart.js');current();
        let conflict=pendingSwitch(cart);
        if (switchToken && conflict && conflict.item.properties[switchProperty]===switchToken && conflict.item.quantity===1 && otherSignature(conflict.others)===originalOthers) {
          try {cart=await request('cart/change.js',{id:conflict.item.key,quantity:0});current();} catch {}
        }
        remember(cart);unresolved=pendingSwitch(cart);
      } catch {}
      if (run!==generation) return false;
      showError(button,unresolved ? text('recovery_error') : (error.assemblyMessage || error.shopifyMessage || text(['preorder_wait','selection_changed'].includes(error.message)?error.message:'error')));
      if(unresolved)showRecovery(button,unresolved);
      track('pk_checkout_error',{...event,reason:error.message || 'unknown'});return false;
    } finally {
      if (run===generation) {pending=false;resetButtons();}
    }
  };
  const resume = async button => {
    if (pending) return false;
    dismissPrompt();clearStatus();pending=true;const run=++generation;setBusy(button);
    track('pk_checkout_resume',{placement:'header'});
    try {
      let cart=await request('cart.js');if(run!==generation)return false;
      if(!remember(cart)){showError(button,text('empty'));return false;}
      const conflict=pendingSwitch(cart);
      if(conflict){showError(button,text('recovery_error'));showRecovery(button,conflict);return false;}
      if (window.PKAssembly) {
        const sauna=cart.items.find(isSauna);
        const variant=sauna ? String(sauna.variant_id) : '';
        const intent=await window.PKAssembly.prepare(variant,cart);if(run!==generation)return false;
        cart=await window.PKAssembly.sync(variant,cart,intent);if(run!==generation)return false;
        remember(cart);
      }
      location.assign(root+'checkout');return true;
    } catch(error){showError(button,error.assemblyMessage || error.shopifyMessage || text('error'));track('pk_checkout_error',{placement:'header',reason:error.message || 'unknown'});return false;}
    finally{if(run===generation){pending=false;resetButtons();}}
  };
  const reset = () => {generation++;pending=false;dismissPrompt();resetButtons();clearStatus();refresh();};
  window.PKCheckout = {start,resume,refresh,reset};
  document.addEventListener('click',event=>{
    if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button!==0)return;
    const resumeButton=event.target.closest('[data-pk-checkout-resume]');
    if(resumeButton){event.preventDefault();resume(resumeButton);return;}
    const button=event.target.closest('[data-pk-direct="buy"]');
    if(!button)return;
    event.preventDefault();
    const title=button.dataset.model || button.querySelector('.visually-hidden')?.textContent.replace(/^:\s*/,'') || '';
    start({variant:button.dataset.variant,productId:button.dataset.productId,model:nameOf({title}),gifts:(button.dataset.gifts||'').split(','),button,placement:button.closest('[id]')?.id || location.pathname});
  });
  window.addEventListener('pageshow',event=>{if(event.persisted)reset();});
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible'&&!pending)refresh();});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh,{once:true});else refresh();
})();

/* Make expanded customer reviews a direct path to the model shown. */
(() => {
  const models = [{"name": "Mini", "url": "/products/peak-saunas-mini-1-person-indoor-full-spectrum-infrared-sauna-with-medical-grade-red-light-therapy"}, {"name": "Shasta", "url": "/products/peak-saunas-shasta-1-person-indoor-near-zero-emf-full-spectrum-infrared-sauna-with-xl-medical-grade-red-light-therapy-smart-wifi-app-control"}, {"name": "Rainier", "url": "/products/peak-saunas-rainier-1-person-indoor-near-zero-emf-full-spectrum-infrared-sauna-with-xl-medical-grade-red-light-therapy-smart-wifi-app-control"}, {"name": "Crown", "url": "/products/peak-saunas-crown-2-person-full-spectrum-infrared-sauna"}, {"name": "Everest", "url": "/products/peak-saunas-everest-2-person-indoor-near-zero-emf-full-spectrum-infrared-sauna-with-medical-grade-red-light-therapy"}, {"name": "Fuji", "url": "/products/peak-saunas-fuji-2-person-indoor-near-zero-emf-full-spectrum-infrared-sauna-with-medical-grade-red-light-therapy"}, {"name": "Denali", "url": "/products/peak-saunas-denali-3-person-full-spectrum-infrared-sauna-with-two-xl-medical-grade-red-light-therapy-smart-wifi-app-control"}, {"name": "Matterhorn", "url": "/products/peak-saunas-matterhorn-3-person-full-spectrum-infrared-sauna-with-two-xl-medical-grade-red-light-therapy-smart-wifi-app-control"}, {"name": "Patagonia", "url": "/products/peak-saunas-patagonia-2-person-outdoor-full-spectrum-infrared-sauna-with-smart-wifi-app-control"}, {"name": "El Capitan", "url": "/products/peak-saunas-el-capitan-4-person-outdoor-full-spectrum-infrared-sauna-with-smart-wifi-app-control"}, {"name": "Kilimanjaro", "url": "/products/peak-saunas-kilimanjaro-5-person-outdoor-full-spectrum-infrared-sauna-with-smart-wifi-app-control"}];
  const prepare = () => document.querySelectorAll('.pkj-pf--photos .jdgm-carousel-item').forEach(card => {
    if (card.querySelector('.pk-review-model-link')) return;
    const body = card.querySelector('.jdgm-carousel-item__body');
    const image = card.querySelector('.jdgm-carousel-item__product-image');
    if (!body || !image) return;
    const title = (image.alt || '').toLowerCase();
    const match = models.find(model => new RegExp('\\b' + model.name.toLowerCase() + '\\b').test(title));
    const link = document.createElement('a');
    link.className = 'pk-review-model-link';
    link.href = match ? match.url : '/collections/saunas?view=peak-shop';
    link.textContent = match ? 'View ' + match.name : 'Shop all saunas';
    link.addEventListener('click', event => event.stopPropagation());
    body.append(link);
  });
  const section = document.querySelector('.pkj-pf--photos');
  if (!section) return;
  prepare();
  new MutationObserver(prepare).observe(section, {childList:true,subtree:true});
})();

